export const reducer = (state, action) => {
  let facets;
  switch (action.type) {
    case 'enableDistance':
      return { ...state, enableDistance: action.enable };

    case 'edit':
      return { ...state, editing: !state.editing };

    case 'update': {
      const filteredFacets = state.facets.filter(({ queryStringId }) => queryStringId.indexOf(action.key) === -1);

      facets = [].concat(filteredFacets, action.facet);

      return { ...state, facets };
    }

    case 'add': {
      facets = [].concat(state.facets, action.facet);

      return { ...state, facets };
    }

    case 'remove': {
      facets = state.facets.filter(({ queryStringId }) => queryStringId !== action.facet.queryStringId);
      const { children } = action.facet;

      if (children && children.length > 0) {
        const queryStrings = children.map((child) => child.queryStringId);
        facets = facets.filter((val) => queryStrings.indexOf(val.queryStringId) === -1);
      }

      return { ...state, facets };
    }

    case 'frequency':
      return { ...state, frequency: action.value };

    case 'delete':
      return { ...state, isDeleted: false };

    case 'error': {
      return { ...state, isError: action.value };
    }

    case 'save':
    case 'warn': {
      return { ...state, ...{ ...action.value } };
    }

    case 'cancel': {
      state[action.value] = false;

      return { ...state };
    }

    case 'job-count': {
      const value = action.value > 0;
      return { ...state, hasJobs: value };
    }

    default:
      return state;
  }
};
